import { ChaineLogo } from '@chain-zen/ui'

export const ChainLoader = () => {
  return (
    <div className="flex flex-1 items-center justify-center h-screen w-auto">
      <div className="relative flex flex-col items-center space-y-4">
        {/* Ring spinner with logo in center */}
        <div className="relative">
          {/* Animated ring */}
          <div className="w-20 h-20 border-4 border-gray-200 border-t-primary rounded-full animate-spin"></div>

          {/* Logo in center */}
          <div className="absolute inset-0 flex items-center justify-center">
            <ChaineLogo size="md" className="h-10 w-10" />
          </div>
        </div>
      </div>
    </div>
  )
}
